import { TextInput, Button, Tooltip } from '@ui/kit';
import { SelectTrigger } from '../../../../molecules/select-panel/select-trigger.js';
import { shortenLevel } from '../../../../utils/shorten-level.js';
import { createStore } from './_create-drawer.state.js';
import { headingCls, descriptionCls, formCls, buttonsCls } from './base-panel.style.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

function BasePanel(props) {
  const course = createStore.useSelector(state => state);

  // Input is considered invalid once it is empty and dirty
  const isTitleEmpty = !course.title;
  const isTitleInvalid = typeof course.title === "string" && isTitleEmpty;
  const formattedLevels = course.levels.length > 2 ? course.levels.map(shortenLevel) : course.levels;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("h1", {
      className: headingCls,
      children: "Opret forl\xF8b"
    }), /*#__PURE__*/jsx("p", {
      className: descriptionCls,
      children: "Opret et forl\xF8b og v\xE6lg de sektioner, du \xF8nsker at samle og dele med dine elever."
    }), /*#__PURE__*/jsxs("form", {
      className: formCls,
      onSubmit: props.onSubmit,
      noValidate: true,
      children: [/*#__PURE__*/jsx(TextInput, {
        required: true,
        invalid: isTitleInvalid,
        label: "Titel",
        value: course.title ?? "",
        onChange: value => createStore.dispatch(createStore.actions.setTitle(value)),
        maxLength: 100
      }), /*#__PURE__*/jsx(SelectTrigger, {
        label: "Fag",
        valuePlaceholder: "V\xE6lg fag",
        optional: true,
        selectedValues: course.subjects,
        onClick: props.enableSubjectPanel
      }), /*#__PURE__*/jsx(SelectTrigger, {
        label: "Niveau",
        valuePlaceholder: "V\xE6lg niveau",
        optional: true,
        selectedValues: formattedLevels,
        onClick: props.enableLevelPanel
      }), /*#__PURE__*/jsxs("div", {
        className: buttonsCls,
        children: [/*#__PURE__*/jsx(Button, {
          theme: "secondary",
          type: "button",
          onClick: props.onClose,
          children: "Annuller"
        }), /*#__PURE__*/jsx(Tooltip, {
          placement: "top",
          body: "Titel skal udfyldes",
          ariaType: "description",
          disabled: !isTitleEmpty,
          children: ref => /*#__PURE__*/jsx(Button, {
            "aria-disabled": isTitleEmpty,
            ref: ref,
            theme: "primary",
            showSpinner: props.isSubmitting,
            type: "submit",
            children: "Opret"
          })
        })]
      })]
    })]
  });
}

export { BasePanel };
//# sourceMappingURL=base-panel.js.map
